import React, {useState, useRef, useEffect, Fragment} from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { MdDragHandle } from "react-icons/md";
import {FieldDropdown, TextField, Divider, ViewLabelValueField, UserIcon, VisDiv, AddButton, NonConformityPin, SliderRegistriTemplates, InsertPhotoSanity} from '../../components';
import { addValueForDropdown, errorAlert, keyId, sortByLabel, sortByOrder, resizeBase64, fromBase64ToSanity, successAlert } from '../../lib/utils';
import { ArrayReference } from '../management/ManageSchema';
import { TiDelete } from 'react-icons/ti';
import { useStateContext } from '../../context/StateContext';
import { v4 as uuidv4, v4 } from 'uuid';
import TrueFalseToggle from '../TrueFalseToggle';
import ImageCrop from '../../components/imageCrop/ImageCrop'
import { urlFor } from '../../lib/client';
import { CgProfile } from 'react-icons/cg';
import { useUploadPhoto } from '../../hooks/mutations';
import RichTextEditor from '../RichTextEditor';
import { useCreateReplace } from '../../hooks/mutations';
import { FaImages } from "react-icons/fa";
import { IoMdImages } from "react-icons/io";
import { useQueryClient } from '@tanstack/react-query';
import { referenceDoc } from '../gestioneDatabase/Docs';
import { MdStickyNote2 } from "react-icons/md";
import {FiEdit} from 'react-icons/fi'
import register from '../../sanity_ecommerce/schemas/register';



const ManagementModules = () => {
  return (
    <div>
       ManagementModules
    </div>
  )
}

export default ManagementModules

export const ReferenceCheckList = ({doc, setDoc, referenceData, dataCallback = ()=>{}}) => {

    const propertyName = referenceData?.propertyName  
    const disabledIds = referenceData?.disabledIds ? referenceData?.disabledIds : []

    const existingList = (doc) => doc[`${propertyName}`]?.length > 0 ? doc[`${propertyName}`]?.map?.((x)=>{
        const findDoc = !Array.isArray(referenceData?.data) ? undefined : referenceData?.data?.find?.((y)=>y?._id == x?._ref)
        if(findDoc?.family) return ({label:findDoc?.family, _id:findDoc?._id})
        if(findDoc?.name) return ({label:findDoc?.name, _id:findDoc?._id})
        return ({label:findDoc?.label, _id:findDoc?._id})
        
    }):[]



    const [list, setList] = useState(existingList(doc))

    useEffect(()=>{setList(existingList(doc))}, [doc, referenceData])

    const save = (data) => {
        setDoc(data)
        setList(existingList(data))
    }
    const testFunction = () => {
        console.log("TEST REFERENCE CHECKLIST", existingList(doc), doc )
    }
    return (    
    <div style={{marginTop:"10px"}}>
        <VisDiv rules={[false]}>
            <button onClick={testFunction}>TEST REFERENCE CHECKLIST</button> 
        </VisDiv>
        <h4>DATI PRESENTI:</h4>
        <div style={{marginBottom:"10px"}}>
            {list?.sort(sortByLabel)?.map?.((item, index)=>{
                const deleteLine = () => {
                    const newDoc = {...doc, [`${propertyName}`]:doc[`${propertyName}`]?.filter?.((x)=>x?._ref !== item?._id)}
                    setList(existingList(newDoc))
                    setDoc(newDoc)
                    //console.log(doc, newDoc)   
                }
                return(
                    <div key={item?._key ? item?._key : index } style={{display:"flex"}}>
                        <VisDiv rules={[false]} style={{marginRight:"10px"}}>
                            <button
                                type="button"
                                className="remove-item"
                                onClick={() => deleteLine()}
                                >
                                <TiDelete />
                            </button>
                        </VisDiv>
                    <p style={{padding:"3px"}} key={index}>{item?.label}</p>
                </div>
                )
            }) 
            }
        </div>
        <ArrayReference 
            dataCallback={dataCallback}
            fullWidth={true}
            hideFilter={referenceData?.hideFilter}
            disabledIds={disabledIds}
            data={referenceData} 
            //closeEditingSide={setEditingSide} 
            directSave={true}
            doc={doc}
            setDoc={save} />
    </div>
)
}

export const ArrayOfObjects = ({data = {}, doc, setDoc}) => {

const {arrayName, buttonTitle="AGGIUNGI", title="", objectSchema = [], labelValueDistance=5, emptyObject={}} = data
const existingArray = doc?.[arrayName] ? doc?.[arrayName] : []
const [addingNew, setAddingNew] = useState(false)
const {LDB} = useStateContext();
const testFunction = () => {
    console.log("TEST ARRAY OF OBJECTS", data, "DOC", doc)
}

const addContact = () => {
    //console.log("ADD CONTACT", contactDetails)
    //setAddingNew(!addingNew)
    const contactArray = doc?.[arrayName] ? doc?.[arrayName] : []
    setDoc({...doc, [arrayName]:[...contactArray, {...emptyObject, _id: uuidv4(), _key: keyId(),}]})
    
}

const dottedBorder = {borderRight: 1, borderRightColor: "#d1c5c5", borderRightStyle: "dotted", backgroundColor: "#d3d2d4"}
const headerStyle = {flex:1, padding:"8px", textAlign:"left", ...dottedBorder}
return (
<div>
    <div onClick={testFunction} style={{marginBottom:"15px", display:"flex", justifyContent:"center", alignItems:"center", fontWeight: "bold"}}>
        <h2>{title}</h2>
    </div>
{existingArray?.map?.((item, index)=> {
      const rowColour = index % 2 ? "white":"#f3f4f3"
    return(
        <div style={{backgroundColor:rowColour, padding:"10px"}} key={item?._key}>
            {objectSchema?.sort(sortByOrder)?.map?.((key)=>{
                if(key?.type == "string"){
                    return(
                        <div key={key?.order}>
                            <TextField 
                                label={key?.title}
                                value={item[`${key?.key}`]} 
                                onChange={(e) => {
                                    let array = doc?.[arrayName] ? doc?.[arrayName] : []
                                    array?.splice(index,1,{...item, [key?.key]:e.target.value})
                                    setDoc({...doc, [arrayName]:array})
                                }} 
                                //description={"Questo dato non sarà inserito nell'offerta, serve per trovare il prodotto"} 
                                //descriptionDivider={false}
                        />
                        </div>
                    )
                }
                if(key?.type == "boolean"){
                    return(
                        <VisDiv key={key?.order}>
                            <TrueFalseToggle 
                                value={item[key?.key]}
                                onClick={()=>{
                                    let array = doc?.[arrayName] ? doc?.[arrayName] : []
                                    array?.splice(index,1,{...item, [key?.key]:!item[key?.key]})
                                    setDoc({...doc, [arrayName]:array})
                                }}
                                label={key?.title} 
                                description={key?.fieldDescription}
                            />
                        </VisDiv>)
                }

                
            })}
        </div>
    )
})  
}
{/*     {existingArray?.map?.((item, index)=> {
    return(
        <div key={item?._key}>
            {objectSchema?.sort(sortByOrder)?.map?.((key)=>{
                if(key?.type == "string"){
                    return(
                        <div key={key?.order}>
                            <ViewLabelValueField
                                label={key?.title} 
                                value={item[`${key?.key}`]}
                                labelValueDistance={labelValueDistance}
                            />
                        </div>)
                }
                if(key?.type == "boolean"){
                    return(
                        <VisDiv key={key?.order}>
                            <ViewLabelValueField
                                //label={item?.label} 
                                value={key?.boolValue}
                                labelValueDistance={labelValueDistance}
                                highlight={key?.highlight}
                            />
                        </VisDiv>)
                }

                
            })}
        </div>
    )
})  
} */}
<AddButton
    label={addingNew ? "CHIUDI" : buttonTitle}
    onClick={addContact}
/>
<VisDiv rules={[addingNew]}>
{/*     <ContactDetail 
        resetAfterSave={true} 
        noArchive={true} 
        alwaysEdit={true} 
        saveFn={saveFn}
        contact={contactDoc}
    /> */}
    test
</VisDiv>
</div>
)

}

export const ImageUploadAndCrop = ({doc, setDoc, skipCrop, sImageKey="image", size=176, profile = true}) => {
    //const {apiUrl} = useStateContext();
    const [photo, setPhoto] = useState(undefined);
    const [cropping, setCropping] = useState(false)
    const iconSize  = {width:`${size}px`, height:`${size}px`}
    const sanityImage = doc?.[sImageKey]

    const testFunction = () => {
/*         console.log("TEST PIC", doc, sanityImage, photo)
        
        console.log("PIC SIZE", base64Size(photo))
        resizeBase64(photo)?.then((data)=>{
            console.log("NEW PIC", data)
            console.log("PIC SIZE", base64Size(data))
        
        }
        ) */
        console.log("TEST PIC", doc, photo)
        postingUserDocExpress(doc)
    }
     
    const {mutate: uploadPhotoAsset} = useUploadPhoto({
        onError:()=>{
            errorAlert("UPLOAD FOTO NON RIUSCITO")
          } 
    })
    const savePhotoSanity = (asset) => {
        console.log("ASSET SANITY", asset)
        const updatedDoc = {...doc, [sImageKey]: asset}
        setDoc(updatedDoc)
        }

    const croppingFn = (data) => {
        setCropping(data)
    }
    const saveCroppedPhoto = (data) => {
        resizeBase64(data)?.then(async(resizedData)=>{
            const sanityFile = await fromBase64ToSanity(resizedData)
            console.log("NEW PIC", sanityFile)
            //console.log("PIC SIZE", base64Size(resizedData))
            //setPhoto(resizedData)
            uploadPhotoAsset(sanityFile,{
                onSuccess:(asset)=>{
                //console.log("Photo Asset Uploaded", asset);
                const sanityPicDoc = {
                    _type: 'image',
                    _key: keyId(),
                    asset: {
                        _type: 'reference',
                        _ref: asset?._id,
                        _key: keyId()
                      },
                    
                  }
                 
                const updatedDoc = {...doc, [sImageKey]: sanityPicDoc}
                setDoc(updatedDoc)
              }
    
        })
        })
        //postingUserDocExpress(resizedData)
        //setPhoto(data)
        //console.log("SAVED PIC", data)
        
    }
    return (
    <div>
        <div style={{marginTop:"20px", marginBottom:"20px"}}>
            <VisDiv rules={[photo, !sanityImage]}>
                <img style={{...iconSize}} className={profile ? 'profile-icon' : undefined} src={photo}></img>
            </VisDiv>
            <VisDiv rules={[sanityImage]}>
                <img style={{...iconSize}} className={profile ? 'profile-icon' : undefined} src={urlFor(sanityImage)}></img>
            </VisDiv>
            <VisDiv rules={[!sanityImage, profile, !photo]}>
                <CgProfile style={{...iconSize}} className={profile ? 'profile-icon' : undefined} />
            </VisDiv>
            <VisDiv rules={[!sanityImage, !profile, !photo]}>
                <IoMdImages style={{...iconSize}} className={profile ? 'profile-icon' : undefined} />
            </VisDiv>
        </div>
        <VisDiv rules={[!skipCrop]}>
            <ImageCrop isCropping={croppingFn} hidePreview={true} saveFn={saveCroppedPhoto}/>  
        </VisDiv>
        <VisDiv rules={[skipCrop]}>
            <InsertPhotoSanity
                saveSanityFn={savePhotoSanity}
            />    
        </VisDiv>
        {/* <button style={{marginTop:"20px", marginBottom:"20px"}} onClick={testFunction}>TEST PROFILE</button> */}
    </div>
    )
}

export const base64Size = (base64String) => {
    base64String = "data:image/jpeg;base64......";

var stringLength = base64String.length - 'data:image/png;base64,'.length;

var sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
return sizeInBytes/1000;
}

export const Notes = ({doc, setDoc, data={}}) => {
    const [value, setValue] = useState(doc)
    const saveNote = () => {
        //const newValue = {...value, details: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        //console.log("EDITOR BLUR", value)
        setDoc(value)
     }
     const editorDocNote = (data) => {
        //console.log("EDITOR DOC", data)
        const newValue = {...value, notes: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        setValue(newValue)

    }
    return ( 
        <div>
             <RichTextEditor onBlur={saveNote} noFocus={true} existingDoc={doc?.notes} readOnly={false} editorDoc={editorDocNote}/>
        </div>

)
}


export const ManageDocumentReferenceInOtherDocuments = ({doc, query, data={}}) => {
    const queryClient = useQueryClient()
    const {targetArray=[], referenceArrayNameinTargetDocument, showFilters, templateRegisters, customer, setLoading} = data
    const [filterTrue, setFilterTrue] = useState(false);
    const assignedDocuments = !Array.isArray(targetArray) ? [] : targetArray?.filter?.((x)=>x?.[referenceArrayNameinTargetDocument]?.some?.(y=>y?._ref == doc?._id))
    const itemsInList = !Array.isArray(assignedDocuments) ? [] : assignedDocuments?.filter?.((x)=>x?._id == doc?._id)
    const [array, setArray] = useState(itemsInList);
    const [registerTemplateFilter, setRegisterTemplateFilter] = useState(null);
    const [searchNcValue, setSearchNcValue] = useState("");
    const searchNcRef = useRef();

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {
            if(query){
                await queryClient.cancelQueries({ queryKey: query })
                const previousData = queryClient.getQueryData(query)
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData(query, (old) =>{ 
                    
                    const doc = newDoc?.doc
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]  
                    //console.log("bcwkucb setting templateRegisters queryData",{doc, newData})   
                    console.log(`saving ifnailewnc ${query}`)     
                    return newData
                })
                return {previousData }
            }

        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("ERRORE, il documento non é stato aggiornato")
        }
        })

    const save = (data) => {
        console.log("save", data)
        const targetDoc = data?.item
        const action = data?.action
        const referenceDoc = {_type: "reference", _key: keyId(), _ref: doc?._id}
        const referenceArray = targetDoc?.[referenceArrayNameinTargetDocument] ? targetDoc?.[referenceArrayNameinTargetDocument] : []
        if(action == "removed") {
            const docWithItemRemoves = {...targetDoc, [referenceArrayNameinTargetDocument]:[...referenceArray?.filter?.((x)=>x?._ref !== doc?._id)]}
            console.log("item removed", docWithItemRemoves)
            updateDocument({doc: docWithItemRemoves})
        }
        else {
            const docWithItemAdded = {...targetDoc, [referenceArrayNameinTargetDocument]:[...referenceArray?.filter?.((x)=>x?._ref !== doc?._id), referenceDoc]}
            console.log("item added", docWithItemAdded)
            updateDocument({doc: docWithItemAdded})
        }
    }



    const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
      };
      const searchFilter = (x) => {
        const search =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        return search 
    }

    const trueFilter = (y) => {
        const isItemInList = assignedDocuments?.some?.((x)=>x?._id == y?._id)
        if(registerTemplateFilter?._id){
            //console.log("kehbakerbv", {registerTemplateFilter, y})
            return isItemInList || y?.registers?.some?.((x)=>x?._ref == registerTemplateFilter?._id)
        }
        if(filterTrue){
            return isItemInList
        }
        return y
    }
    const testFunction =()=>{console.log("ManageDocumentReferenceInOtherDocuments", doc, data, assignedDocuments)}
    if(!referenceArrayNameinTargetDocument) return <h3>MANCA IL NOME DEL CAMPO NEL DOCUMENTO TARGET</h3>
    return(
        <div>
            <button onClick={testFunction}>ManageDocumentReferenceInOtherDocuments</button>
             <VisDiv rules={[showFilters]}>
            <h4>FILTRA PER FAMIGLIA</h4>
                <div style={{width:"80vw"}}>
                    <SliderRegistriTemplates 
                        registerTemplateFilter={registerTemplateFilter} 
                        setRegisterTemplateFilter={setRegisterTemplateFilter} 
                        templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                        setLoading={setLoading}
                    />
                    
                </div>
            </VisDiv>
            <h4>FILTRA DATI ESISTENTI</h4>
            <TrueFalseToggle value={filterTrue} onClick={()=>setFilterTrue(!filterTrue)}/>
            <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
            </div> 
            {!Array.isArray(targetArray) ? [] : targetArray?.filter?.(searchFilter)?.filter?.(trueFilter)?.sort(sortByLabel)?.map?.((item)=>{
                const isItemInArray = assignedDocuments?.some?.((x)=>x?._id == item?._id)
                return <NonConformityPin
                            key={item?._id}
                            label={item?.label}
                            initialValue = {isItemInArray}
                            itemOnSave={save}
                            item={item}
                            array={array}
                            setArray={setArray}
                        />
                    })}

        </div>
    )
}

export const decimalToHoursConverter = (decimalValue) => {
    const formatDecimalValue = Number(decimalValue)
    if (formatDecimalValue) {
        if(formatDecimalValue * 60 <= 59 ) return ({hours: 0, minutes: formatDecimalValue * 60 })
        if(formatDecimalValue * 60 > 59 ) { 
            const n = new Date(0,0);
            n.setMinutes(+Math.round(formatDecimalValue * 60)); 
            //const days = (n.getDate() - 1)
            const hours = n.getHours()
            const minutes = n.getMinutes()
            return ({hours, minutes})
         
    }}
    return undefined
}

//=======================================================================================

export const DecimalHours = ({docFn=()=>{}, defaultMinutes, initialDecimalValue, description, label, descriptionDivider}) => {

    const [hours, setHours] = useState(decimalToHoursConverter(initialDecimalValue)?.hours)
    const [minutes, setMinutes] = useState(decimalToHoursConverter(initialDecimalValue)?.minutes)

    const decimal = (((hours ? +hours : 0) * 60)+ (minutes ? +minutes : 0))/60
    const valueObject = {hours: Number(Math.round(hours ? hours : 0)), minutes: Number(minutes ? minutes : 0), decimal}

/*     useEffect(()=>{
        docFn(valueObject)
    },[hours, minutes]) */

    return (
        <>
        <div style={{marginBottom:"10px", marginTop:"10px"}}>
         <h4>{label}</h4>
        </div> 
        
        <div style={{display:"flex"}}>
           
            <div style={{width:"70px", marginRight: "10px"}}>
                <p>ORE:</p>
                <TextField 
                    value={hours} 
                    onChange={(e) => setHours(e.target.value)} 
                    //label={"ORE"}
                    onBlur={()=>docFn(valueObject)}
                    type={"number"}
                    pattern="[0-9]"
                />
            </div>
            <div style={{width:"70px"}}>
                <p>MINUTI:</p>
                <TextField 
                    value={minutes} 
                    onChange={(e) => { 
                        if(Number(e.target.value) > 59) setMinutes(59)
                        else setMinutes(e.target.value)}} 
                    //label={"MINUTI"}
                    onBlur={()=>docFn(valueObject)}
                    max={"59"}
                    type={"number"}
                    pattern="[0-9]"
                />
            </div>
        </div>
        <p>{description}</p>
        <VisDiv rules={[description && descriptionDivider]}>
            <Divider/>
        </VisDiv>
        </>
    )
}

export const ReferencesArrayBox =  ({doc, setDoc, referenceData, hideAdd, hideDelete, hideEdit, editDocument = () => {}}) => {
    const {registerTemplate, checkRegisterTemplate, registerTemplateKey, filterAddById, filterAddKey, propertyName, data} = referenceData
    const [emptyDropdownOnSelect, setEmptyDropdownOnSelect] = useState(undefined)

    const disabledIds = referenceData?.disabledIds ? referenceData?.disabledIds : []


    const labelProcess = (findDoc) => {
        if(findDoc?.family) return ({label:findDoc?.family, _id:findDoc?._id})
        if(findDoc?.name) return ({label:findDoc?.name, _id:findDoc?._id})
        return ({label:findDoc?.label, _id:findDoc?._id})
    }
    const array = !Array.isArray(doc[`${propertyName}`]) ? [] : doc[`${propertyName}`]

    const existingList = (doc) => array?.map?.((x, index)=>{
        const findDoc = !Array.isArray(data) ? undefined : data?.find?.((y)=>y?._id == x?._ref)
        return {...labelProcess(findDoc), order: x?.order !== undefined ? x?.order : index}
    })

    const dataOptions = !Array.isArray(data) ? [] : data?.filter?.((x)=>!disabledIds.includes(x?._id))

    const [list, setList] = useState(existingList(doc))

    const allDataOptions = data
    ?.filter((y)=>{
        //console.log("kasjndkjndakjsnd", {filterByAddId: filterAddById, filterAddKey, y})
        if(filterAddById && filterAddKey) return y[filterAddKey]?.some(z=>z?._ref == filterAddById) 
        return y
    })
    ?.filter?.(y=>!list?.some?.(z=>z?._id == y?._id))?.map?.((x)=>{
        const doc = labelProcess(x)
        return ({...doc, value: doc?.label})
    })

    useEffect(()=>{
        setList(existingList(doc))
        //console.log(",ksbdnc,ancakwjnec")
    
    }, [doc, referenceData])

    const save = (data) => {
        setDoc(data)
        setList(existingList(data))
    }
    
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
    
        const items = Array.from(list);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
    
        // Create a completely new array with the correct order
        const newArray = items.map?.((item, index) => {
            return {
                _type: "reference",
                _key: keyId(),
                _ref: item._id,
                order: index
            };
        })?.sort(sortByOrder);
        
        // Create a new document with the new array
        const newDoc = {...doc, [`${propertyName}`]: newArray?.map?.((x)=>(referenceDoc(x._ref)))};
        
        // Update the list state with the new order
        const updatedItems = items.map?.((item, index) => ({
            ...item,
            order: index
        }));
        setList(updatedItems);
        
        // Save the document with the new array        
        // Log for debugging
        console.log("Saving document with new order:");
        save(newDoc)
    }


    
    const testFunction = () => {
        console.log("TEST REFERENCE CHECKLIST", existingList(doc), doc )
    }
    
    return (    
    <div style={{marginTop:"10px"}}>
        <VisDiv rules={[false]}>
            <button onClick={testFunction}>TEST REFERENCE BOX</button> 
        </VisDiv>
        <div style={{marginBottom:"10px", borderRadius:"10px", padding:"10px"}}>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="references">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {list?.sort((a, b) => (a.order || 0) - (b.order || 0))?.map?.((item, index) => {

                                const fullItem = data?.find?.((x)=>x?._id == item?._id)
                                const itemRegisterTemplatesArray = fullItem?.[registerTemplateKey] 
                                const isTemplateInArray = itemRegisterTemplatesArray?.some?.((x)=>x?._ref == registerTemplate?._id)

                                const deleteLine = () => {
                                    const newDoc = {...doc, [`${propertyName}`]: array?.filter?.((x)=>x?._ref !== item?._id)}
                                    setList(existingList(newDoc))
                                    setDoc(newDoc)
                                }
                                return (
                                    <Draggable key={item?._id || index} draggableId={item?._id || `item-${index}`} index={index}>
                                        {(provided) => (
                                            <div 
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginBottom: "5px",
                                                    padding: "5px",
                                                    backgroundColor: "#f9f9f9",
                                                    //borderRadius: "5px",
                                                    borderBottom:"1px solid #CCC", 
                                                    borderTop:"1px solid #CCC"
                                                }}
                                            >
                                                <VisDiv rules={[!hideDelete]} style={{marginRight:"10px"}}>
                                                    <button
                                                        type="button"
                                                        className="remove-item"
                                                        onClick={() => deleteLine()}
                                                    >
                                                        <TiDelete />
                                                    </button>
                                                </VisDiv>
                                                <VisDiv style={{marginRight:"12px"}} rules={[checkRegisterTemplate, !isTemplateInArray]}>
                                                    <MdStickyNote2 size={25} color={"orange"} />
                                                </VisDiv>
                                                <VisDiv rules={[!hideEdit]} style={{marginRight:"10px"}}>
                                                    <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>editDocument(item)}>
                                                        <FiEdit              
                                                        size={15}
                                                        color={"white"}/>
                                                    </button>
                                                </VisDiv>
                                                <VisDiv rules={[true]} style={{marginRight:"10px"}}>
                                                    <button
                                                        type="button"
                                                        className="remove-item"
                                                    >
                                                        <MdDragHandle color={"#ccc"} size={35} />
                                                    </button>
                                                </VisDiv>
                                                <p style={{padding:"3px", flex: 1}}>{item?.label}</p>
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <VisDiv rules={[!hideAdd]}>
                <FieldDropdown
                    isSearchable="isSearchable"
                    options={allDataOptions}
                    onChange={(value) => {
                        save({...doc, [`${propertyName}`]:[...array, referenceDoc(value?._id)]})
                        if(emptyDropdownOnSelect) setEmptyDropdownOnSelect({label:"AGGIUNGI", value:"AGGIUNGI", _id: 1})
                        if(!emptyDropdownOnSelect) setEmptyDropdownOnSelect({label:"AGGIUNGI", value:"AGGIUNGI", _id: 2})
                        
                        }}
                    
                    initialValue={emptyDropdownOnSelect}
                    placeHolder={"AGGIUNGI"}
                />
            </VisDiv>

        </div>
{/*         <ArrayReference 
            fullWidth={true}
            hideFilter={referenceData?.hideFilter}
            disabledIds={disabledIds}
            data={referenceData} 
            //closeEditingSide={setEditingSide} 
            directSave={true}
            doc={doc}
            setDoc={save} /> */}
    </div>
)
}
